import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const FAQS = [{
  q: '¿Cuándo recibo el material?',
  a: 'Inmediatamente después del pago. Recibirás un correo con el enlace de descarga en menos de 2 minutos.'
}, {
  q: '¿Funciona para cualquier tipo de negocio?',
  a: 'Sí. El sistema está basado en psicología de conversación, no en un nicho específico. Funciona para servicios, productos físicos, digitales, consultoría y más.'
}, {
  q: '¿Necesito experiencia previa en ventas?',
  a: 'No. El sistema está diseñado para vendedores que empiezan desde cero y para los que ya venden pero quieren mejores resultados.'
}, {
  q: '¿En qué formato está el material?',
  a: 'Todo en PDF de alta calidad. Compatible con cualquier dispositivo: teléfono, tablet o computadora.'
}, {
  q: '¿Qué pasa si no me funciona?',
  a: 'Tienes 7 días de garantía total. Si no ves resultados, te devolvemos el 100% sin preguntas.'
}, {
  q: '¿El precio sube después?',
  a: 'Esta oferta con los 3 bonos incluidos es de lanzamiento. El precio regular del sistema sin bonos es de $47.00. No podemos garantizar que esta oferta esté disponible mañana.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-white px-4 py-20 sm:px-6 lg:px-8" data-id="element-38">
      <div className="mx-auto max-w-3xl" data-id="element-39">
        <h2 className="mb-12 text-center text-3xl font-bold text-brand-black sm:text-4xl" data-id="element-40">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-41">
          {FAQS.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className={`overflow-hidden rounded-xl border transition-colors ${isOpen ? 'border-brand-green bg-gray-50' : 'border-gray-200 bg-white'}`} data-id="element-42">
                <button className="flex w-full items-center justify-between px-6 py-5 text-left" onClick={() => setOpenIndex(isOpen ? null : idx)} aria-expanded={isOpen} data-id="element-43">
                  <span className="font-bold text-brand-black text-lg" data-id="element-44">
                    {faq.q}
                  </span>
                  {isOpen ? <ChevronUpIcon className="h-5 w-5 text-brand-green flex-shrink-0" data-id="element-45" /> : <ChevronDownIcon className="h-5 w-5 text-gray-400 flex-shrink-0" data-id="element-46" />}
                </button>

                <div className={`px-6 transition-all duration-300 ease-in-out ${isOpen ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-47">
                  <p className="text-gray-600 leading-relaxed" data-id="element-48">{faq.a}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}